var _circle, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdvLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 60,
    viewBox: "0 0 200 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 25,
    fill: "#6d2077",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15, 15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2 L25 8 L25 22 C25 28 20 32 15 35 C10 32 5 28 5 22 L5 8 Z",
    fill: "#6d2077",
    stroke: "#6d2077",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 18 L14 21 L19 13",
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 37.5,
    fontFamily: "Arial, sans-serif",
    fontSize: 28,
    fontWeight: "bold",
    fill: "#6d2077"
  }, "ID-Verify")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdvLogo);
export default __webpack_public_path__ + "static/media/idv-logo.bd37006086f91d0256b3f4fb70136110.svg";
export { ForwardRef as ReactComponent };